import { Link } from "react-router-dom";

export const Brand = ({ light = false, small = false }) => (
  <Link to="/" data-testid="brand-home-link" className="flex items-center gap-3 group shrink-0">
    <img src="/logo.png" alt="Legalia@ Law Firm" className={`${small ? "h-11" : "h-14 sm:h-16"} w-auto rounded-sm transition-shadow ${light ? "ring-1 ring-white/15 group-hover:ring-gold/60" : "shadow-sm"}`} />
    <span className="leading-tight hidden min-[360px]:block whitespace-nowrap">
      <span className={`block font-serif ${small ? "text-base" : "text-lg"} font-semibold ${light ? "text-white" : "text-navy"}`}>Recupero Depositi</span>
      <span className={`block ${small ? "text-[9px]" : "text-[10px]"} uppercase tracking-[0.25em] ${light ? "text-gold" : "text-gold-dark"}`}>Dormienti Consap</span>
    </span>
  </Link>
);

export const SiteHeader = () => (
  <header className="absolute top-0 inset-x-0 z-30">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 sm:h-24 flex items-center justify-between gap-6">
      <div className="shrink-0"><Brand light /></div>
      <nav className="hidden lg:flex items-center gap-6 xl:gap-8 text-sm text-slate-300 whitespace-nowrap min-w-0">
        {[["#come-funziona", "Come funziona"], ["#tariffe", "Tariffe"], ["#chi-siamo", "Chi siamo"], ["#faq", "FAQ"]].map(([h, l]) => (
          <a key={h} href={h} data-testid={`nav-${h.slice(1)}`} className="hover:text-gold transition-colors">{l}</a>
        ))}
        <a href="#verifica" data-testid="nav-verifica-cta" className="px-4 py-2 rounded-full border border-gold/60 text-gold hover:bg-gold hover:text-navy transition-colors">Verifica gratuita</a>
      </nav>
      <a href="#verifica" data-testid="nav-verifica-cta-compact" className="hidden md:inline-flex lg:hidden shrink-0 whitespace-nowrap px-4 py-2 rounded-full border border-gold/60 text-gold text-sm hover:bg-gold hover:text-navy transition-colors">Verifica gratuita</a>
    </div>
  </header>
);
